/* eslint-disable no-param-reassign */
import { canUseDom, agnostifyUrl } from './utils'

export const defaultImgParams = '?qlt=50&fmt=pjpeg&defaultimage=prod-img-placeholder'
export const defaultImgParamsTrans = '?qlt=50&defaultimage=prod-img-placeholder'
export const serverImgParams = '?qlt=25&fmt=pjpeg&defaultimage=prod-img-placeholder&$poi$&w=400&blur=8,5'

export const ensureStructure = (window) => {
  window.digitalData = window.digitalData || {}
  window.digitalData.page = window.digitalData.page || {}
  window.digitalData.page.lightBox = window.digitalData.page.lightBox || {}
  window.digitalData.page.lightBox.type = window.digitalData.page.lightBox.type || []
  window.digitalData.page.lightBox.clickOrigin = window.digitalData.page.lightBox.clickOrigin || ''
  window.digitalData.page.lightBox.currentTab = window.digitalData.page.lightBox.currentTab || ''
  window.digitalData.page.lightBox.product = window.digitalData.page.lightBox.product || []
  window.digitalData.page.ugc = window.digitalData.page.ugc || {}
  window.digitalData.page.ugc.filters = window.digitalData.page.ugc.filters || []
  window.digitalData.event = window.digitalData.event || []
  window.digitalData.page.productFinder = window.digitalData.page.productFinder || {}
  window.digitalData.track = window.digitalData.track || (() => {})
}

export const trackEvent = (event, window) => {
  ensureStructure(window)
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
}

export const isBlackFriday = (window) =>
  window && window.location && window.location.pathname === '/events/black-friday'

// Maybe we can delete this later
const shopNowCTAPaths = ['/events/black-friday', '/events/home-sale', '/events/jan-sales', '/events/new-range']

export const hasProductCardCTAOverride = (window) =>
  window && window.location && shopNowCTAPaths.includes(window.location.pathname)

export const smoothScrollSupported = () => 'scrollBehavior' in document.documentElement.style

export const viewports = { MOBILE: 'MOBILE', SMALL: 'SMALL', MEDIUM: 'MEDIUM', LARGE: 'LARGE' }
export const breakpointPx = { MOBILE: 481, SMALL: 576, MEDIUM: 768, LARGE: 993 }
export const breakpoints = {
  MOBILE: `only screen and (min-width: ${breakpointPx.MOBILE}px)`,
  SMALL: `only screen and (min-width: ${breakpointPx.SMALL}px)`,
  MEDIUM: `only screen and (min-width: ${breakpointPx.MEDIUM}px)`,
  LARGE: `only screen and (min-width: ${breakpointPx.LARGE}px)`
}

export const onLinkClickFn = (e, onLinkClick, linkUrl) =>
  typeof onLinkClick === 'function' ? onLinkClick(e, agnostifyUrl(linkUrl)) : false

export const getWrapperProps = (linkTitle, linkUrl, onLinkClick, baseWrapperProps = {}) => {
  let wrapperProps = baseWrapperProps

  if (linkUrl) {
    wrapperProps = {
      ...wrapperProps,
      onClick: (event) => onLinkClickFn(event, onLinkClick, linkUrl),
      title: linkTitle,
      href: agnostifyUrl(linkUrl),
      forwardedAs: 'a'
    }
  }

  return wrapperProps
}

export const transformedProps = (citrus, type, props) => {
  const commonProps = {
    type,
    heading: props.roundel?.content?.header || props.roundel?.header || props.bannerText,
    image: {
      url: props.heroImage,
      altText: props.heroImageAltText
    },
    backgroundColor: `#${props.backgroundColour}`,
    roundel: props.roundel,
    citrus
  }
  const linkProps = {
    url: props.ctaLink,
    title: props.ctaTextAccessibility,
    target: '_self',
    copy: props?.ctaText || 'Shop now',
    style: 'primary'
  }
  const subHeading =
    props.roundel?.content?.body || props.roundel?.body || (props.roundel?.header ? props.bannerText : '')

  if (type === 'M053') {
    return {
      ...commonProps,
      links: [linkProps],
      bodyCopy: subHeading
    }
  }
  if (type === 'C001' || type === 'C004') {
    const commonCompProps = {
      ...commonProps,
      ...(props.isSecondaryHeading && { isSecondaryHeading: props.isSecondaryHeading }),
      ...(type === 'C004' && { placement: props.placement })
    }

    return {
      ...commonCompProps,
      imageStyle: 'short',
      link: linkProps,
      subheading: subHeading,
      mobileImagePosition: 'top',
      tabletImagePositionTop: props.tabletImagePositionTop
    }
  }

  return props
}

export const fetcher = async (url, options) => {
  const response = await fetch(url, options)
  const json = await response.json()

  return {
    json,
    status: response.status,
    ok: response.ok
  }
}
export class ComponentHelper {
  static windowWidth(isMobileBreakpoint) {
    if (canUseDom()) {
      const breakpoint = isMobileBreakpoint ? breakpointPx.MOBILE : breakpointPx.SMALL
      if (window.innerWidth > breakpoint) return viewports.LARGE
      return viewports.SMALL
    }
    return viewports.SMALL
  }

  static dynamicImageParams(imgUrl, windowSize = viewports.SMALL, type, width, aspectRatio = true) {
    if (!imgUrl) return ''
    if (!type) return imgUrl + serverImgParams
    const isHero = ['M001']
    const isFullWidthGroup = ['M0041']
    const isHalfMobileFullDesktop = ['M0013']
    const isOneThirdWidthGroup = ['M020-size-4']
    const isFlatImageBanner = ['M020', 'M020-size-8']
    const img = isFlatImageBanner.includes(type)
      ? `${imgUrl}?qlt=85&fmt=pjpeg&defaultimage=prod-img-placeholder`
      : imgUrl + defaultImgParams
    if (isFullWidthGroup.includes(type)) {
      if (windowSize === viewports.SMALL) return `${img}&$poi$&w=768${aspectRatio ? '&sm=aspect&aspect=1:1' : ''}`
      return `${img}&$poi$&w=960${aspectRatio ? '&sm=aspect&aspect=1.5:1' : ''}`
    }
    if (isHero.includes(type)) {
      if (windowSize === viewports.SMALL) return `${img}&$poi$&w=768&sm=aspect&aspect=1.5:1`
      return `${img}&$poi$&w=960&sm=aspect&aspect=1.5:1`
    }
    if (isOneThirdWidthGroup.includes(type)) {
      if (windowSize === viewports.SMALL) return `${img}&$poi$&w=735${aspectRatio ? '&sm=aspect&aspect=1:1' : ''}`
      return `${img}&$poi$&w=550${aspectRatio ? '&sm=aspect&aspect=1:1' : ''}`
    }
    if (isFlatImageBanner.includes(type)) {
      if (width) return `${img}&w=${width}`
      if (windowSize === viewports.MOBILE) return `${img}&w=550`
      return `${img}&w=960`
    }
    if (isHalfMobileFullDesktop.includes(type)) {
      if (windowSize === viewports.SMALL) return `${img}&$poi$&w=735&sm=aspect&aspect=1:1`
      return `${img}&w=1170`
    }
    return ''
  }

  static gridLayout(type, index, childLength) {
    if (type === 'GL003' || type === 'GL006-lg') {
      const position = index + 1
      if (childLength === 1) {
        return 12
      }
      if (childLength === 3) {
        return 4
      }
      if (
        position === 1 ||
        (childLength === 4 && position === 4) ||
        ([6, 9].includes(childLength) && [4, 5].includes(position)) ||
        (childLength === 7 && position === 7)
      ) {
        return 8
      }
      return 4
    }
    if (type === 'GL006') {
      const position = index + 1
      if (([3, 4, 6].includes(childLength) && [1, 4].includes(position)) || (childLength === 5 && position === 1)) {
        return 12
      }
      if ([3, 4].includes(childLength) || ([5].includes(childLength) && [2, 3, 4, 5].includes(position))) {
        return 6
      }
      return 6
    }
    if (type === 'M035') {
      const position = index + 1
      if (childLength === 2) {
        return { md: 6 }
      }
      if (childLength === 3) {
        if (position === 3) return { md: 4, sm: 12 }
        return { md: 4 }
      }
      if (childLength === 5) {
        if ([1, 2].includes(position)) return { md: 6 }
        if (position === 5) return { md: 4, sm: 12 }
      } else if (childLength === 7) {
        if ([1, 2, 3].includes(position)) return { md: 6, lg: 4 }
        if (position === 4) return { md: 6, lg: 3 }
        if (position === 7) return { md: 4, lg: 3, sm: 12 }
        return { md: 4, lg: 3 }
      } else if (childLength === 4 || childLength === 8 || childLength === 12) {
        return { md: 3 }
      }
      return { md: 4 }
    }
    return ''
  }

  static dynamicAspectRatio(categoryNavigationView, offerSize) {
    switch (categoryNavigationView) {
      case viewports.MOBILE:
        return '1:1'
      case viewports.SMALL:
        return '1:0.8'
      default:
    }
    switch (offerSize) {
      case 4:
        return '1:1'
      case 8:
        return '1:0.5'
      case 12:
        return '1:1'
      default:
        return '1:1'
    }
  }

  static validComponentArrayOfObjects(componentArray) {
    return componentArray.filter((comp) => (comp.type === 'M010' && comp.validProduct === true) || comp.type !== 'M010')
  }
}

export const cleanString = (str) => {
  // Remove spaces and special characters
  const cleanedString = str.replace(/[^\w\s]/gi, '').replace(/\s/g, '')
  const lowercaseString = cleanedString.toLowerCase()

  return lowercaseString
}
